<template>
  <footer class="tw-bg-green tw-p-8 tw-text-white">
    <div class="tw-mx-auto tw-max-w-4xl">
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-4 sm:tw-flex-row sm:tw-justify-between">
        <!-- Logo and Info -->
        <div class="tw-flex tw-flex-col tw-items-center sm:tw-items-start">
          <div class="tw-mb-2 tw-flex tw-items-center">
            <img 
              :src="require('@/assets/logo_Logo.png')" 
              alt="Turtlemeet Logo" 
              class="tw-h-6 tw-mr-2 tw-brightness-0 tw-invert"
            />
            <span class="tw-text-xl tw-font-medium">Turtlemeet</span>
          </div>
          <div class="tw-text-sm tw-text-white/80 tw-text-center sm:tw-text-left">
            Self-hosted 
            <a
              href="https://timeful.app"
              target="_blank"
              class="tw-underline hover:tw-text-white"
            >Timeful</a>
            instance
          </div>
        </div>

        <!-- Links -->
        <div class="tw-flex tw-flex-col tw-items-center sm:tw-items-end tw-gap-2">
          <div class="tw-flex tw-items-center tw-gap-4">
            <a
              href="https://github.com/schej-it/timeful.app"
              aria-label="GitHub"
              target="_blank"
              class="tw-text-white/80 hover:tw-text-white"
            >
              <v-icon class="tw-text-white/80 hover:tw-text-white">mdi-github</v-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
}
</script>
